import script from "./OrgForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrgForm.vue?vue&type=script&setup=true&lang=ts"

import "./OrgForm.vue?vue&type=style&index=0&id=a98076b0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a98076b0"]])

export default __exports__